import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const BetalingVoltooid = () => (
  <section className="min-h-[60vh] py-24 bg-neutral-50">
    <div className="max-w-xl mx-auto px-5 md:px-10 text-center">
      <div className="bg-white border border-neutral-200 p-10">
        <CheckCircle2 size={48} className="text-emerald-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-neutral-900 mb-3">Bedankt voor uw betaling</h1>
        <p className="text-neutral-600 leading-relaxed mb-8">
          Uw betaling wordt verwerkt. U ontvangt binnen enkele minuten een bevestiging per e-mail.
          Mocht er iets niet kloppen, neem dan gerust contact met ons op via{" "}
          <a href="mailto:info@computheer.nl" className="underline">info@computheer.nl</a> of{" "}
          <a href="tel:+31612562049" className="underline">06-12562049</a>.
        </p>
        <Link to="/" className="inline-block bg-neutral-900 hover:bg-black text-white px-6 py-3 text-sm font-medium">
          Terug naar computheer.nl
        </Link>
      </div>
    </div>
  </section>
);

export default BetalingVoltooid;
